import PropTypes from 'prop-types';

const labels = ['Selecionar PGs', 'Regiões e bairros', 'Montar vans', 'Conferir e enviar'];
export default function PlanningSteps({ current }) {
  return <ol className="rf-workflow" aria-label="Etapas do planejamento">
    {labels.map((label,index) => <li key={label} aria-current={current === index + 1 ? 'step' : undefined}>
      <span className="rf-workflow-number">{index + 1}</span><span className="rf-workflow-label">{label}</span>
    </li>)}
  </ol>;
}
PlanningSteps.propTypes = { current: PropTypes.oneOf([1,2,3,4]).isRequired };
